export const MIN_WEIGHT_KG = 30;
export const MAX_WEIGHT_KG = 300;

// Elfogadja a vesszős és pontos tizedes elválasztót is (magyar billentyűzet).
function parseWeight(value: string): number {
  return parseFloat(value.replace(",", "."));
}

/**
 * Testreszabott súly-validáció a napló bejegyzés (új/szerkesztés) és a
 * profil/kezdősúly mezőkhöz. Magyar hibaüzenetet ad vissza, vagy null-t,
 * ha az érték érvényes.
 */
export function validateWeight(value: number | string | ""): string | null {
  if (value === "" || value === null || value === undefined) {
    return "A súly megadása kötelező.";
  }

  const num = typeof value === "number" ? value : parseWeight(value);

  if (Number.isNaN(num)) {
    return "Érvénytelen súlyérték.";
  }

  if (num < MIN_WEIGHT_KG || num > MAX_WEIGHT_KG) {
    return `A súly ${MIN_WEIGHT_KG} és ${MAX_WEIGHT_KG} kg között lehet.`;
  }

  if (Math.abs(Math.round(num * 10) - num * 10) > 1e-9) {
    return "A súly legfeljebb egy tizedesjegyet tartalmazhat.";
  }

  return null;
}

/**
 * Elindítható-e a GYORS súly-mentés (Napló teteje, a súly-mező melletti
 * „Mentés" gomb).
 *
 * ⚠️ Miért külön függvény (2026-09-17, QA N1): a Napló képernyőn KÉT
 * „Mentés" gomb van, és mindkettő ugyanazt a `weight` állapotot olvassa —
 * a felső gyors-mentés (csak súly) és a lenti teljes űrlap (súly nélkül is
 * menthet, D2). A gyors gomb korábban ÜRES súlynál is aktív maradt, és
 * megnyomásra „A súly megadása kötelező." üzenetet adott — miközben a
 * lenti űrlap ugyanazt a bejegyzést simán elmentette. A tesztelő ezt a
 * D2-javítás hibájának olvasta, pedig a gombok félreérthetősége volt.
 *
 * Ugyanaz a csapda-minta, amit a D2 döntés megnevezett: a kontroll
 * használhatónak látszik, aztán a művelet elhasal. A gyors-mentésnek
 * SZÜKSÉGE van a súlyra (az az egyetlen tartalma), ezért itt a hiány
 * tiltás, nem hibaüzenet.
 */
export function canQuickSaveWeight(value: number | string | ""): boolean {
  return value !== "" && validateWeight(value) === null;
}
